/**
=========================================================
* Material Dashboard 2 PRO React - v2.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-pro-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
import Autocomplete from "@mui/material/Autocomplete";
import { styled } from "@mui/material/styles";

export default styled(Autocomplete)(({ theme }) => {
  // The Autocomplete component uses theme configuration from:
  // - assets/theme/components/form/autocomplete.js
  // - assets/theme-dark/components/form/autocomplete.js
  // These are already applied via the theme provider, so we just return the base component
  return {};
});

